import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonFunctions } from '../common-functions';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class StoreService {
  public server = environment.APIEndpoint;
  public urls: any = {
   // getSecStoreList: this.server + 'app/store/get/v1',
    getUnsecStoreList: this.server + 'app/unsec/store/get/v1',
    previousStore:this.server+'api/store/get/v1/previousStores',
    getStoreById: this.server + 'app/store/view/v1',
    addremoveToFavStore:this.server + 'app/add/favoriteStores/v1',
    getFavStore:this.server + 'app/favoriteStores/v1',
    dynamicStoreLink:this.server + 'api/unsec/dynamic/link/v1/share',
    viewStoreSecure:this.server+'api/store/v2/view?storeId=',
    viewStoreUnecure:this.server+'api/unsec/store/v2/view?storeId='
  };
  public deviceMetaInfo = {
    "appVersion":"",
    "deviceCountry":"India",
    "deviceCity":"",
    "deviceId":localStorage.getItem("deviceId"),
    "deviceModel":"",
    "platform":"KIOSK",
    "deviceOSVersion":""
  };
  public unsecureHeaderData = {
    'Accept-Language': 'EN',
    'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
  }
  public guestHeader = {
    'Accept-Language': 'EN',
    'GuestToken': localStorage.getItem('guestUserToken'),
    'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
  }
  public headerData = {
    'Accept-Language': 'EN',
    'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
    'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
  };
  isLoggedIn: boolean;
  constructor(private http: HttpClient,private storageService:StorageService,private commonFunction: CommonFunctions,private apiHeader: ApiHeaderService) {
    this.isLoggedIn = this.commonFunction.verifyLoggedInUser();
  }
  getStores(requestPayload): any {
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    let headerData = {
      'Accept-Language': 'EN',
      'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
      'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
    };
    let guestHeader = {
      'Accept-Language': 'EN',
      'GuestToken': localStorage.getItem('guestUserToken'),
      'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
    }
    if (isLoggedIn) {
      return this.http.post(this.urls.getSecStoreList, requestPayload, { headers: headerData });
    } else {
     return this.http.post(this.urls.getUnsecStoreList, requestPayload, { headers: guestHeader });
    }
  }
  addRemoveToFavStore(requestPayload){
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    let headerData = {
      'Accept-Language': 'EN',
      'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
      'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
    };
    if(isLoggedIn){
      return this.http.post(this.urls.addremoveToFavStore, requestPayload, { headers: headerData });
    }
  }
  getFaviuoriteStore(requestPayload){
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    let headerData = {
      'Accept-Language': 'EN',
      'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
      'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
    };
    if(isLoggedIn){
      return this.http.post(this.urls.getFavStore, requestPayload, { headers: headerData });
    }
  }
  viewStoreDetail(requestPayload){
    let isLoggedIn = this.commonFunction.verifyLoggedInUser();
    let headerData = {
      'Accept-Language': 'EN',
      'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
      'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
    };
    let guestHeader = {
      'Accept-Language': 'EN',
      'GuestToken': localStorage.getItem('guestUserToken'),
      'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
    }
    if(isLoggedIn){
      return this.http.post(this.urls.viewStoreSecure+requestPayload, requestPayload, { headers: headerData });
    }else{
      return this.http.post(this.urls.viewStoreUnecure+requestPayload, requestPayload, { headers: guestHeader });
    }
  }
  getPrevStore(){
   let isLoggedIn = this.commonFunction.verifyLoggedInUser();
  let headerData = {
    'Accept-Language': 'EN',
    'Authorization': 'Bearer' + ' ' + this.storageService.getAccessToken(),
    'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo)
  };
    if(isLoggedIn){
      return this.http.get(this.urls.previousStore, { headers: headerData });
    }
  }
  storeCache$: Observable<any>;
  getStoresCache(req){
    if(!this.storeCache$){
     this.storeCache$ = this.getStores(req).pipe(
       shareReplay(1),
     );
   }
   return this.storeCache$;
  }
  clearStoreList(){
    this.storeCache$ = null;
  }
  getStoreDynamicLink(queryParam){
    let unsecureHeaders = this.apiHeader.getUnSecureHeader();
    return this.http.get(this.urls.dynamicStoreLink +'?type=StoreDetail&value=' + queryParam, { headers: unsecureHeaders });
  }
  viewStoreLocal$: Observable<any>;
  viewStoreLocal(req){
    if(!this.viewStoreLocal$){
     this.viewStoreLocal$ = this.viewStoreDetail(req).pipe(
       shareReplay(1),
     );
   }
   return this.viewStoreLocal$;
  }
}
